import { render, staticRenderFns } from "./AddNoteDialog.vue?vue&type=template&id=79244913&scoped=true&"
import script from "./AddNoteDialog.vue?vue&type=script&lang=js&"
export * from "./AddNoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddNoteDialog.vue?vue&type=style&index=0&id=79244913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79244913",
  null
  
)

export default component.exports